import PubSub from 'pubsub-js';

export const publish = (event, payload) => {
  PubSub.publish(event, payload);
};

export const subscribe = (event, callback) => {
  const token = PubSub.subscribe(event, (msg, data) => callback(data));
  return token;
};

export const unsubscribe = (token) => {
  PubSub.unsubscribe(token);
};

// export default {
//   publish,
//   subscribe,
//   unsubscribe,
// };
